import type { Locale } from "date-fns";
import { da } from "date-fns/locale/da";
import { nb } from "date-fns/locale/nb";


const locale: Locale = process.env.NEXT_PUBLIC_WEBSITE_BRAND === "kinodk" ? da : nb;
export { locale };
